module.exports = __webpack_public_path__ + "media/icons/card-2-9fabbe90.png";